import React, { Component } from 'react';
import './../PersonRegist.css'
import Api from '../../../api/wxapi';
import intl from 'react-intl-universal';
import Select from 'react-select';
import { inject ,observer} from 'mobx-react';
import ReactEcharts  from 'echarts-for-react';


//技师奖励
@inject('store')
@observer
export default class rewardjs extends Component {
  constructor(props) {
    super();
    this.state = {
      name: "",
      device_number: "",
      store: "",
      device_count: "",
      transform_count: "",
      bounty:"",
      storename: '',
      username:'',
      headurl:'',
      option:'',
      scan_count:'',//累计扫描数量
      tire_count:'',      //累计轮胎条数
      service_count:'',//累计服务次数
      scan_award:'',//累计扫描奖励
      transform_award:''//累计转化奖励
    };

  }

  componentDidMount() {
    document.title = '技师奖励'
     this.wxrz()
     this.getUser() 
     this.getOption()
  }
  render() {
    let {
      name,
      device_number,
      device_count,
      transform_count,
      bounty,
      headurl,
      storename,
      username,
      option,
      scan_count,
      tire_count,      //累计轮胎条数
      service_count,//累计服务次数
      scan_award,//累计扫描奖励
      transform_award//累计转化奖励

    } = this.state

    return (
      <div className='flex-column-container' style={{ paddingLeft: 12, paddingRight: 12, flex: 1, marginTop: 12 ,backgroundColor:"#fff"}}>
       <div className='flex-row-container' style={{ alignItems: 'center', marginTop: 15, marginLeft: 15, marginRight: 15,justifyContent:'space-around' }}>
          <img
            src={headurl}
            alt=""
            style={{ width: 60, height: 60, objectFit: "contain" }}
          />
          <div className='flex-row-container' style={{ justifyContent: "space-between", flex: 1, alignItems: 'center' }} >
            <div style={{ marginLeft: 15  }}>
             <p>{username}</p>
             <p> {storename}</p> 
            </div>


            <button  onClick={this.submit}  className= {'pc-button'}>{'领取奖励'}</button>
          </div>
        </div>



        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>设备ID</p>
          <p> {device_number}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 
         <h2 style={{marginTop:'20px'}}>检测累计</h2> 
         
         <div className='flex-row-container' style={{marginTop:'20px',alignItems:'center'}}>
            <div className='flex-column-container' style={{flex:1,alignItems:'center'}}>
              <p>扫描车辆</p>
              <p>{scan_count}辆</p>
            </div>
            <p style={{height:'20px',backgroundColor:'#F4F4F4',width:'2px'}}></p>  
            
            <div className='flex-column-container' style={{flex:1,alignItems:'center'}}>
              <p>转化轮胎</p>
              <p>{tire_count}条</p>
            </div>
            <p style={{height:'20px',backgroundColor:'#F4F4F4',width:'2px'}}></p>  
            <div className='flex-column-container' style={{flex:1,alignItems:'center'}}>
              <p>轮胎服务</p>
              <p>{service_count}次</p>
            </div>
         </div>

         <p style={{height:2,backgroundColor:'#F4F4F4',width:'100%',marginTop:'10px'}}></p>


         <h2 style={{marginTop:'20px'}}>激励累计</h2> 
         
         <div className='flex-row-container' style={{marginTop:'20px',alignItems:'center',width:'66%'}}>
            <div className='flex-column-container' style={{flex:1,alignItems:'center'}}>
              <p>扫描激励</p>
              <p>￥{scan_award}</p>
            </div>
            <p style={{height:'20px',backgroundColor:'#F4F4F4',width:'2px'}}></p>  
            
            <div className='flex-column-container' style={{flex:1,alignItems:'center'}}>
              <p>转化激励</p>
              <p>￥{transform_award}</p>
            </div>
            <p style={{height:'20px',backgroundColor:'#F4F4F4',width:'2px'}}></p>  
          
         </div>

         <p style={{height:2,backgroundColor:'#F4F4F4',width:'100%',marginTop:'10px'}}></p>

         <h2 style={{marginTop:'20px',marginBottom:'20px'}}>当日统计</h2> 
       
          {option&&(<div style={{flex:1}}> <ReactEcharts option={option}  style={{width:'100%',height:'300px'}}></ReactEcharts></div>)} 
       
         {/** 
        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>所属门店</p>
          <p> {store}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 


        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>扫描车辆</p>
          <p> {device_count}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 

        
        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>转化车辆</p>
          <p> {transform_count}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 


        <div>
        <div className='flex-row-container' style={{justifyContent:"space-between",paddingTop:10,paddingBottom:10}}>
          <p>奖励金额</p>
          <p> {bounty}</p>
        </div>
         <p style={{flex:1,height:2,backgroundColor:'#F4F4F4',width:'100%'}}></p>
        </div> 


        <button className="pr-button" onClick={this.submit}>{'领取奖励'}</button>*/}
      </div>
    )
  }


  wxrz(){
   
    let code=this.props.store.getQueryString('code')
    let wxappid=global.constants.wxappid
    let secret=global.constants.secret

    let redirect_uri1= this.props.store.rootUrl+'person/reward/RewardJs'
    let registurl= this.props.store.rootUrl+'person/PersonRegist'
    let rurl=encodeURI(redirect_uri1)
      console.log(rurl)
  /*  wxApi.getUser().then(res=>{
      console.log(res)
   }) */
   
   //先尝试从缓存中获得用户信息
   let userStr=sessionStorage.getItem('user');
   if(userStr&& userStr.length>0){
       let data=JSON.parse(userStr)
       this.props.store.updateOpenId(data.openid)
       sessionStorage.setItem('openid',data.openid)
       if(data.is_auth){

        this.setState({
        username:data.nickname,
        storename:data.storename,
        headurl:data.headimgurl,
        })
         this.getdata();
      
       }else {
         window.location.href=registurl
       } 
       
   } else{
    if(code){
      Api.getUserInformation({ code:code})
      .then(res=>{
        console.log(res)
        if(res.data.code==0){
          let data=res.data.data
          sessionStorage.setItem('user',JSON.stringify(data))
          this.props.store.updateOpenId(data.openid)
          sessionStorage.setItem('openid',data.openid)
          if(data.is_auth){
            window.location.href=redirect_uri1
          }else {
            window.location.href=registurl
          }  
        }
         
      }) 
    /* wxApi.getOpenId({appid:wxappid,secret:secret,code:code,grant_type:'authorization_code'}).then(res=>{
        console.log(res)
      }) */ 
      
    }else {
      let wxrzurl=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxappid}&redirect_uri=${rurl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      window.location.href = wxrzurl;
    } 
   }
  }

  getdata() {

    Api.getjsRewardInfomation().then(res => {
      if (res.data.code == 0) {
        let data = res.data.data
        this.setState({
          name: data.name,
          device_number: data.device_number,
          storename: data.store,
          device_count: data.device_count,
          transform_count: data.transform_count,
          bounty:data.bounty,
          scan_count:data.scan_count,
          tire_count:data.tire_count,
          service_count:data.service_count,
          scan_award:data.scan_award,
          transform_award:data.transform_award
        })
        let data1=[data.today_stat.scan.amount,data.today_stat.sale_tire.amount,data.today_stat.sale_other.amount]
        let data2=[data.today_stat.scan.count,data.today_stat.sale_tire.count,data.today_stat.sale_other.count]
        this.getOption(data1,data2)
      }
    })
  }


  getUser(){
     //先尝试从缓存中获得用户信息
   let userStr=sessionStorage.getItem('user');
   if(userStr&& userStr.length>0){
       let data=JSON.parse(userStr)
       this.setState({
        username:data.nickname,
        openid:data.openid,
        isRegist:data.is_auth,//是否认证
        headurl:data.headimgurl,
      }) 
    }  
  }

  getOption(data1,data2){
    let option = {
      tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
      },
      legend: {
          data: ['激励金额', '检测情况']
      },
      barGap:'0%',
      grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
      },
      xAxis: [
          {
              type: 'category',
              data: ['扫描车辆', '转化轮胎', '轮胎服务',]
          }
      ],
      yAxis: [
          {
              type: 'value',
              max:20
          }
      ],
      series: [
          {
              name: '激励金额',
              type: 'bar',
              data: data1,
              itemStyle: {
                normal:{
                  label:{
                    show:true,
                    position:'top',
                    formatter: '¥'+ "{c}"
                  }
                }               
              }
          },
          {
              name: '检测情况',
              type: 'bar',
              stack: '广告',
              data: data2,
              itemStyle: {
                normal:{
                  label:{
                    show:true,
                    position:'top',
                    formatter: "{c}"
                  }
                }               
              }
              
          },
         
      ]
  };
     this.setState({option:option})
      
  }


  submit=()=>{
    this.props.history.push('/person/reward/Reward') 
  }

}



// WEBPACK FOOTER //
// ./src/views/person/reward/rewardjs.js